import { connect } from 'react-redux';
import { getSearchType, getIsMobile } from '../../../modules/Settings';
import { PageContent } from './Content';
import { getNumberOfJobs, getPageTitle } from '../../../modules/Seo';

const mapStateToProps = state => ({
  searchType: getSearchType(state),
  isMobile: getIsMobile(state),
  numberOfJobs: getNumberOfJobs(state),
  pageTitle: getPageTitle(state)
});

const mapCallbacksToProps = () => ({});

export const Content = connect(mapStateToProps, mapCallbacksToProps)(PageContent);

